import React, { Component } from 'react';
import { withStyles } from '@material-ui/styles';
import PropTypes from 'prop-types';

import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Button,
} from '@material-ui/core';

import { useStyles } from './styles.js';

class TableView extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  /** LIFE CYCLE METHODS */
  componentDidMount() {}

  /**RENDER METHOD */
  render() {
    const { classes } = this.props;

    return (
      <TableContainer>
        <Table aria-label="simple table">
          <TableHead>
            <TableRow>
              {Object.keys(this.props.table_headers).map(key => {
                return <TableCell>{this.props.table_headers[key]}</TableCell>;
              })}
            </TableRow>
          </TableHead>
          <TableBody>
            {this.props.table_data.map((data, index) => {
              return (
                <TableRow>
                  <TableCell component="th" scope="row">
                    {index + 1}
                  </TableCell>
                  {Object.keys(data).map(data_key => {
                    return (
                      <TableCell component="th" scope="row">
                        {data[data_key]}
                      </TableCell>
                    );
                  })}
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    );
  }
}

TableView.propTypes = {
  className: PropTypes.string,
};

export default withStyles(useStyles)(TableView);
